import {
  START_LOADING,
  END_LOADING,
  FETCH_INVENTORY,
  FETCH_INVENTORY_ITEM,
  CREATE_INVENTORY_ITEM,
  UPDATE_INVENTORY_ITEM,
  DELETE_INVENTORY_ITEM,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  inventoryItems: [],
  currentInventoryItem: null,
  numberOfPages: 0,
  currentPage: 1,
};

const inventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };

    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_INVENTORY:
      return {
        ...state,
        inventoryItems: action.payload?.inventoryItems || [],
        numberOfPages: action.payload?.numberOfPages || 1,
        currentPage: action.payload?.currentPage || 1,
      };

    case FETCH_INVENTORY_ITEM:
      return {
        ...state,
        currentInventoryItem: action.payload,
      };

    case CREATE_INVENTORY_ITEM:
      return {
        ...state,
        inventoryItems: [...state.inventoryItems, action.payload],
      };

    case UPDATE_INVENTORY_ITEM:
      return {
        ...state,
        inventoryItems: state.inventoryItems.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
        currentInventoryItem: action.payload,
      };

    case DELETE_INVENTORY_ITEM:
      return {
        ...state,
        inventoryItems: state.inventoryItems.filter(
          (item) => item._id !== action.payload
        ),
        currentInventoryItem: null,
      };

    default:
      return state;
  }
};

export default inventoryReducer;
